var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "empty-collection" }, [
    _c("img", {
      staticClass: "collection-img",
      attrs: { src: _vm.src, alt: _vm.label },
    }),
    _c(
      "a",
      {
        staticClass: "button--link",
        attrs: { href: _vm.href, disabled: _vm.disabled },
      },
      [
        _vm.icon
          ? _c("icon", { attrs: { name: _vm.icon, size: _vm.iconSize } })
          : _vm._e(),
        _c("span", [_vm._v(_vm._s(_vm.label))]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }